import { render, staticRenderFns } from "./M2hChallenges.vue?vue&type=template&id=3ee7c988&scoped=true&"
import script from "./M2hChallenges.vue?vue&type=script&lang=js&"
export * from "./M2hChallenges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee7c988",
  null
  
)

export default component.exports